import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

//import utils
import { calculateDiscountPercent, numberWithCommas } from "../../../../utils/utility";

//import styles
import "./price-card.scss";

function PriceCard({ priceItem }) {
    //general variables
    const { t } = useTranslation();

    //define the price list for different types of customers
    const pricingOptions = [
        { id: 1, priceKey: "adult_price", discountKey: "adult_discount_price", label: t("adult") },
        { id: 2, priceKey: "child_price_without_bed", discountKey: "child_discount_price_without_bed", label:  `${t("child")} (${t("withoutBed")})` },
        { id: 3, priceKey: "child_price_with_bed", discountKey: "child_discount_price_with_bed", label:`${t("child")} (${t("withBed")})`  },
    ];

    //check if a tour has a discount
    const hasDiscount = (price, discountPrice) => {
        return discountPrice && price - discountPrice !== 0;
    };

    return (
        <Grid className="price-card" container item xs={12} rowGap={1}>
            <Grid container item xs={12}>
                {priceItem?.name}
            </Grid>
            <Grid container item xs={12}>
                <span className="price-card__tag">{priceItem?.services}</span>
            </Grid>
            <Grid container item xs={12}>
                {t("perEach")}:
            </Grid>

            {pricingOptions?.map(item => {
                return (
                    <Grid className="price-card__price-details" key={item.id} container item xs={12} justifyContent="space-between" alignItems="center">
                        <Grid container item xs="auto">
                            {item.label}
                        </Grid>
                        <Grid container item xs={7} justifyContent="flex-end" alignItems="center">
                            {hasDiscount(priceItem[item.priceKey], priceItem[item.discountKey]) ? (
                                <>
                                    <span className="price-card__percent">
                                        {calculateDiscountPercent(priceItem[item.priceKey], priceItem[item.discountKey])}
                                    </span>
                                    <Grid container item xs={8} direction="column" alignItems="flex-end">
                                        <span className="price-card__discount-price">{numberWithCommas(priceItem[item.discountKey])} {t("currency")}</span>
                                        <span className="price-card__origin-price">{numberWithCommas(priceItem[item.priceKey])} {t("currency")}</span>
                                    </Grid>
                                </>
                            ) : (
                                <span className="price-card__discount-price">{numberWithCommas(priceItem[item.priceKey])} {t("currency")}</span>
                            )}
                        </Grid>
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default PriceCard;
